import { Flex, Form } from 'dash-ui';
import styled from 'styled-components';

export const FlexWraper = styled(Flex)`
  flex-direction: row;
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
  }
`;

export const FormGroupWraper = styled(Form.Group)`
  margin-top: 2px;
  padding-right: 10px;
  @media ${({ theme }) => theme.devices.mobile} {
    padding-right: 0;
  }
`;
